import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';

import { convertToMexicoTime } from 'utils/helpers/convertToMexicoTime';

const DownloadPortabilityForm = ({
  onSubmit,
  loading,
  processCompleted,
  setProcessCompleted,
  errorMessage,
}) => {
  const [currentDate, setCurrentDate] = useState('');
  const [downloadType, setDownloadType] = useState(null);
  const [downloadSource, setDownloadSource] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    const today = new Date().toISOString();
    const todayMexico = convertToMexicoTime(today);
    setCurrentDate(todayMexico.split(' ')[0]);
  }, []);

  useEffect(() => {
    if (processCompleted) {
      setProcessCompleted(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processCompleted]);

  const handleProcessClick = () => {
    onSubmit(selectedDate, downloadType, downloadSource);
  };

  return (
    <Grid sx={{ width: { xs: '100%', md: '80%' } }} paddingLeft={5}>
      <Grid size={12} container spacing={2} paddingTop={3} alignItems='center' wrap='nowrap'>
        <Grid size={3}>
          <FormControl fullWidth>
            <InputLabel>Selecciona el tipo</InputLabel>
            <Select
              value={downloadSource}
              onChange={(e) => setDownloadSource(e.target.value)}
              label='Selecciona el tipo'
            >
              <MenuItem key={1} value={'dalefon'}>
                Dalefon
              </MenuItem>
              <MenuItem key={2} value={'ipb'}>
                IPB
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={5}>
          <FormControl fullWidth>
            <InputLabel>Selecciona lugar de descarga</InputLabel>
            <Select
              value={downloadType}
              onChange={(e) => setDownloadType(e.target.value)}
              label='Selecciona lugar de descarga'
            >
              <MenuItem key={1} value={'Storage'}>
                Descargar de Storage
              </MenuItem>
              <MenuItem key={2} value={'SFTP'}>
                Descargar de SFTP
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid size={3}>
          <TextField
            fullWidth
            type='date'
            label='Fecha'
            slotProps={{
              inputLabel: { shrink: true },
              htmlInput: {
                max: currentDate,
              },
            }}
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </Grid>
      </Grid>

      <Grid mt={3} display='flex' alignItems='center' gap={2}>
        <Button
          variant='contained'
          disabled={(!downloadType && !selectedDate) || loading}
          sx={{
            backgroundColor: downloadType && selectedDate ? 'primary.main' : 'grey.400',
            paddingX: 6,
            paddingY: 1.5,
            width: 'auto',
            whiteSpace: 'nowrap',
            textTransform: 'none',
          }}
          onClick={handleProcessClick}
        >
          {loading ? <CircularProgress size={20} /> : 'Descargar archivo'}
        </Button>

        {/*downloadType === "SFTP" && (
                    <Grid display="flex" alignItems="center" gap={1}>
                        <Checkbox
                            checked={replaceFile}
                            onChange={(e) => setReplaceFile(e.target.checked)}
                        />
                        <Typography>
                            ¿Quieres reemplazar el archivo de portabilidades
                            guardado en el storage con el de SFTP?
                        </Typography>
                    </Grid>
                )*/}
      </Grid>
      <br />
      {errorMessage && (
        <Typography variant='body1' color='error'>
          {errorMessage}
        </Typography>
      )}
    </Grid>
  );
};

export default DownloadPortabilityForm;
